import { render, staticRenderFns } from "./SaleTaxGroupCreate.vue?vue&type=template&id=aaf86ab0&"
import script from "./SaleTaxGroupCreate.vue?vue&type=script&lang=ts&"
export * from "./SaleTaxGroupCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports